import { render, staticRenderFns } from "./SolanLookbackPure.vue?vue&type=template&id=1026acfc&scoped=true&"
import script from "./SolanLookbackPure.vue?vue&type=script&lang=ts&"
export * from "./SolanLookbackPure.vue?vue&type=script&lang=ts&"
import style0 from "./SolanLookbackPure.vue?vue&type=style&index=0&id=1026acfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1026acfc",
  null
  
)

export default component.exports